import BaseComponent from "../baseComponent.js";
import PreLoader from "../common/preloader.jsx";
import TermsAndConditions from "./termsAndConditions.jsx";
import VerifyEmail from "./verifyEmail.jsx";
import IdentityAccessService from "../../core/services/identityAccessService.js";
import styles from "./sign-up.scss";

export default class SignUp extends BaseComponent {
  constructor(props, context) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      username: "",
      password: "",
      passwordConfirm: "",
      agreement: false,
      error: null
    }
  }

  handleCreateBtnClick() {
    // this.refs.terms.show();
    if (this.validate()) {
      this.refs.terms.show();
    }
  }

  sendCreateUserRequest() {
    this.refs.terms.hide();

    let user = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      userId: this.state.username,
      email: this.state.username,
      password: this.state.password
    };

    IdentityAccessService.createUser(user)
      .then(res => {
        $(this.refs.signupForm).hide();
        this.refs.terms.hide();
        this.refs.verifyEmail.show();
      })
      .catch(err => {
        this.setState({
          error: "This email has already been registered."
        });
      });
  }

  toLoginPage() {
    this.context.router.replace("/login");
  }

  validate() {   //simple validation for sign up form
    var isValid = true, message = "";

    if (this.state.firstName.length === 0) {
      $(this.refs.firstName).addClass("invalid");
      $(this.refs.firstName).siblings(".custom-error").show();
      isValid = false;
    }

    if (this.state.lastName.length === 0) {       //ensure last name is greater than 0 character
      $(this.refs.lastName).addClass("invalid");
      $(this.refs.lastName).siblings(".custom-error").show();
      isValid = false;
    }

    if (this.state.username.length === 0) {     //ensure first name is greater than 0 character
      $(this.refs.username).addClass("invalid");
      $($(this.refs.username).siblings(".custom-error")[0]).show();
      isValid = false;
    } else if(!validateEmail(this.state.username)) {
      isValid = false;
      $($(this.refs.username).siblings(".custom-error")[1]).show();
    }

    if (this.state.password.length === 0) {      //ensure password is greater than 0 character
      $(this.refs.password).addClass("invalid");
      $(this.refs.password).siblings(".custom-error").show();
      isValid = false;
    }

    if (isValid) {        //ensure password is match
      if (this.state.password !== this.state.passwordConfirm) {
        this.setState({
          error: "Password does not match."
        });
        isValid = false;
      }
    }

    return isValid;
  }



  showLoader() {
    $(this.refs.backdrop).show();
    this.refs.preloader.show();
  }

  hideLoader() {
    $(this.refs.backdrop).hide();
    this.refs.preloader.hide();
  }

  handleChange(field) {
    var _this = this;
    return function (event) {
      var state = {
        error: null
      };
      state[field] = event.target.value;
      _this.setState(state);

      $(_this.refs[field]).siblings(".custom-error").hide();
    };
  }

  getUserEmail() {
    return this.state.username;
  }

  render() {
    var error;

    if (this.state.error) {
      error = <div className="col s12">
        <div className="login-modal__error">
          <span>{this.state.error}</span>
        </div>
      </div>
    }

    return (
      <div className={styles.backdrop} style={{zIndex: 2000}}>
        <div className="row signup-form" ref="signupForm">
          <div className="col s12 signup-modal__title"><span>Create Account</span></div>
          {error}
          <form className="col s12">
            <div className="row">
              <div className="input-field col s6">
                <input id="account-fname" type="text" className="validate" ref="firstName"
                       value={this.state.firstName}
                       onChange={this.handleChange('firstName')}/>
                <label htmlFor="account-fname">First Name</label>
                <div className="custom-error">First name is required.</div>
              </div>
              <div className="input-field col s6">
                <input id="account-lname" type="text" className="validate" ref="lastName"
                       value={this.state.lastName}
                       onChange={this.handleChange('lastName')}/>
                <label htmlFor="account-lname">Last Name</label>
                <div className="custom-error">Last name is required.</div>
              </div>
              <div className="input-field col s12">
                <input id="account-username" type="email" className="validate" ref="username"
                       value={this.state.username}
                       onChange={this.handleChange('username')}/>
                <label htmlFor="account-username">Email address</label>
                <div className="custom-error">Email address is required.</div>
                <div className="custom-error invalid-email">Invalid email address.</div>
              </div>
              <div className="input-field col s12">
                <input id="account-password" type="password" className="validate" ref="password"
                       value={this.state.password}
                       onChange={this.handleChange('password')}/>
                <label htmlFor="account-password">Password</label>
                <div className="custom-error">Password is required.</div>
              </div>

              <div className="input-field col s12">
                <input id="account-password-confirm" type="password" className="validate"
                       ref="passwordConfirm"
                       value={this.state.passwordConfirm}
                       onChange={this.handleChange('passwordConfirm')}/>
                <label htmlFor="account-password-confirm">Confirm Password</label>
              </div>

            </div>
          </form>
          <div className="col s12 signup-form__actions">
            <div onClick={this.toLoginPage}>I have a Smash account</div>
            <a className="waves-effect waves-light btn login-modal__login-btn"
               onClick={this.handleCreateBtnClick}>Create</a>
          </div>
          <div className={styles.preloader} ref="backdrop">
            <PreLoader ref="preloader"/>
          </div>
        </div>
        <TermsAndConditions onAgree={this.sendCreateUserRequest} onCancel={this.handleCancel} ref="terms"/>
        <VerifyEmail ref="verifyEmail" getUserEmail={this.getUserEmail}></VerifyEmail>
      </div>
    )
  }
}

SignUp.contextTypes = {
  router: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/auth/signUp.jsx